import { useState, useEffect } from 'react';
import ReactModal from 'react-modal';
import { ArrowLeftIcon, ArrowRightIcon, CloseIcon } from '@ag1/ui';
import clsx from 'clsx';
import { getRootElement } from '../../utils/getRootElement';
import ModalYoutubeVideosIconButton from './ModalYoutubeVideosIconButton/ModalYoutubeVideosIconButton';
import styles from './ModalYoutubeVideos.module.scss';

type ModalYoutubeVideosProps = {
  isOpen: boolean;
  onClose: () => void;
  videoUrls: string[];
  videoIndex?: number;
  theme?: 'old' | 'new';
};

const ROOT_ELEMENT = getRootElement();

if (ROOT_ELEMENT) {
  ReactModal.setAppElement(ROOT_ELEMENT);
}

const ModalYoutubeVideos = (props: ModalYoutubeVideosProps) => {
  const { isOpen, onClose, videoUrls, videoIndex = 0, theme = 'old' } = props;

  const [currentVideoIndex, setCurrentVideoIndex] = useState(videoIndex);

  useEffect(() => {
    setCurrentVideoIndex(videoIndex);
  }, [videoIndex]);

  const goPrev = () => {
    setCurrentVideoIndex((oldValue) => (oldValue + videoUrls.length - 1) % videoUrls.length);
  };

  const goNext = () => {
    setCurrentVideoIndex((oldValue) => (oldValue + 1) % videoUrls.length);
  };

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      className={clsx(styles.modal, theme === 'new' ? styles.newTheme : '')}
      shouldReturnFocusAfterClose={false}
      overlayClassName={styles.overlay}>
      {videoUrls.length > 1 && (
        <div className={styles.navigationButtons}>
          <ModalYoutubeVideosIconButton className={styles.navigationIcon} onClick={goPrev}>
            <ArrowLeftIcon />
          </ModalYoutubeVideosIconButton>
          <ModalYoutubeVideosIconButton className={styles.navigationIcon} onClick={goNext}>
            <ArrowRightIcon />
          </ModalYoutubeVideosIconButton>
        </div>
      )}
      <div className={styles.iframeContainer}>
        <iframe
          className={styles.iframe}
          width="100%"
          height="auto"
          src={videoUrls[currentVideoIndex]}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="Embedded youtube"
        />
      </div>
      <ModalYoutubeVideosIconButton onClick={onClose} className={styles.closeButton}>
        <CloseIcon size={24} />
      </ModalYoutubeVideosIconButton>
    </ReactModal>
  );
};

export default ModalYoutubeVideos;
